package com.patronat.top.client.domain.location

import com.patronat.top.client.data.location.ClientLocationSearchRepository
import com.patronat.top.client.location.ClientGeoLocation
import com.patronat.top.client.location.ClientLocationSuggestion
import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase

data class SearchClientLocationsCommand(
    val query: String,
    val proximity: ClientGeoLocation?
)

class SearchClientLocationsUseCase(
    private val repository: ClientLocationSearchRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<SearchClientLocationsCommand, DomainResult<List<ClientLocationSuggestion>>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: SearchClientLocationsCommand): DomainResult<List<ClientLocationSuggestion>> {
        return repository.searchLocations(
            query = command.query,
            proximity = command.proximity
        )
    }
}
